<template>
  <div class="text-xs-center text-center">
    <div
      v-for="(objectState, index) in $store.getters.objectStatesByModule[module.moduleName]"
      style="position: relative;float:left;"
    >
      <v-btn
        :key="index"
        :color="color(objectState)"
        class="right-triangle ml-1 my-1"
        depressed
        dark
        @click="toggleStateFilter(objectState)"
      >
        <v-icon
          v-if="objectState.icon"
          small
          :color="iconColor(objectState)"
          class="mr-2"
        >
          {{ objectState.icon }}
        </v-icon>
        <span v-if="showTitle" :style="'color:' + textColor(objectState)">
          {{ objectState['stateNameText_' + $store.state.language] || objectState['stateNameText_en'] }}
        </span>

      </v-btn>

      <v-icon
        v-if="objectState.nextStates && objectState.nextStates.length > 0"
        :key="index + '_i'"
        small
        dark
        color="white"
        class="to-next-state state-next-circle"
        style=""
        @click="toggleStateFilter(objectState)"
      >
        fa-circle
      </v-icon>

      <v-icon
        v-if="objectState.nextStates && objectState.nextStates.length > 0"
        :key="index + '_i2'"
        small
        dark
        :color="isSelected(objectState) ? color(objectState) : '#B0BEC5'"
        class="to-next-state"
        style=""
        @click="toggleStateFilter(objectState)"
      >
        fa-arrow-circle-right
      </v-icon>
    </div>
    <v-btn
      icon
      text
      @click="clearStateFilter()"
      style="position: relative;float:left;"
      class="right-triangle ml-1 my-1"
    >
      <v-icon>close</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'ModuleListStatesFilter',

  data () {
    return {
      lastFilterPickTimestamp: 0
    }
  },

  props: {
    module: {
      type: Object,
      default: () => {
        return {}
      }
    },

    showFormNextToList: {
      type: Boolean,
      default: false
    },

    openList: {
      type: Function,
      default: () => {}
    }
  },

  computed: {
    stateFilter() {
      return this.$store.state.searchFilters[this.module.moduleName + '__states'] || []
    },

    showTitle () {
      if (this.$vuetify.breakpoint.mdAndUp && !this.showFormNextToList) {
        return true
      }
      return false
    }
  },

  methods: {
    color (objectState) {
      return this.isSelected(objectState)
        ? objectState.color || 'grey'
        : 'grey lighten-2'
    },

    iconColor (objectState) {
      return this.isSelected(objectState)
        ? 'white'
        : objectState.color || 'grey'
    },

    textColor (objectState) {
      return this.isSelected(objectState)
        ? 'white'
        : '#546E7A'
    },

    isSelected (objectState) {
      return this.stateFilter.includes(objectState.id)
    },

    clearStateFilter () {
      this.$store.dispatch('clearStateFilter', this.module.moduleName)
      this.openList()
    },

    toggleStateFilter (objectState) {
      const moduleStateFilters = this.$store.state.searchFilters[this.module.moduleName + '__states']
      const isCurrentFilterOn = moduleStateFilters && moduleStateFilters.find(filterId => filterId === objectState.id)
      const singleFilterIsSame = moduleStateFilters && moduleStateFilters.length === 1 && isCurrentFilterOn
      let timePassed = +new Date() - this.lastFilterPickTimestamp
      if (timePassed > 2000 && !singleFilterIsSame) {
        this.$store.dispatch('clearStateFilter', this.module.moduleName)
      }
      this.$store.dispatch('toggleStateFilter', {
        moduleName: this.module.moduleName,
        objectState: objectState
      })
      this.lastFilterPickTimestamp = +new Date()
      this.openList()
    }
  }


}
</script>

<style>
.to-next-state {
  position: absolute !important;
  top: 14px;
  right: -8px;
  color: white;
  z-index: 1;
}
.state-next-circle {
  font-size: 22px !important;
  top: 11px;
  right: -11px;
}
</style>
